import React, { useEffect, useCallback } from 'react';
import Constantes from "../../constantes";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function ConfiguracionGrupo() {

    const navigate = useNavigate();

    const group_id = useParams().id;
    const [group_name, setGroup_Name] = React.useState("");
    const [descripcion, setDescripcion] = React.useState("");
    const [solicitudesPendientes, setSolicitudesPendientes] = React.useState([]);
    const [usuariosActivos, setUsuariosActivos] = React.useState([]);

    const [esOwner, setEsOwner] = React.useState(false);

    async function expulsarUsuario(usuarioId) {
        try {
            if (esOwner) {
                console.log("Expulsando usuario:", usuarioId, "del grupo:", group_id);
                const respuesta = await fetch(Constantes.RUTA_API + '/miembros_grupos/expulsarMiembro', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ grupoId: group_id, usuarioId })
                });
                const data = await respuesta.json();
                alert(data.message);
                fetchUsuariosActivos();
            } else {
                console.log("Usuario saliendo del grupo:", usuarioId, "del grupo:", group_id);
                const respuesta = await fetch(Constantes.RUTA_API + '/miembros_grupos/salirGrupo', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ grupoId: group_id, usuarioId })
                });
                const data = await respuesta.json();
                alert(data.message);
                navigate('/GyC');
            }
        } catch (error) {
            console.error('Error al expulsar usuario:', error);
        }
    }

    useEffect(() => {
        async function verificarEsOwner() {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/grupos/esOwner/' + group_id, {
                    method: 'GET',
                    credentials: 'include'
                });
                const data = await respuesta.json();
                if (!data.error) {
                    setEsOwner(data.esOwner);
                }
            } catch (error) {
                console.error('Error al verificar si el usuario es propietario del grupo:', error);
            }
        }
        verificarEsOwner();
    }, [group_id]);

    useEffect(() => {
        async function fetchGrupoDetalles() {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/grupos/detalles/' + group_id, {
                    method: 'GET',
                    credentials: 'include'
                });
                const data = await respuesta.json();
                if (!data.error) {
                    setGroup_Name(data.grupo.nombre);
                    setDescripcion(data.grupo.descripcion);
                }
            } catch (error) {
                console.error('Error al obtener los detalles del grupo:', error);
            }
        }
        fetchGrupoDetalles();
    }, [group_id]);

    const fetchSolicitudesPendientes = useCallback(async () => {
        try {
            const respuesta = await fetch(Constantes.RUTA_API + '/invitaciones/getInvitacionesGrupo/' + group_id, {
                method: 'GET',
                credentials: 'include'
            });
            console.log("Respuesta de solicitudes pendientes:", respuesta);
            const data = await respuesta.json();
            if (!data.error) {
                setSolicitudesPendientes(data.message);
            }
        } catch (error) {
            console.error('Error al obtener las solicitudes pendientes:', error);
        }
    }, [group_id]);

    const fetchUsuariosActivos = useCallback(async () => {
        try {
            if (!esOwner) {
                const respuesta = await fetch(Constantes.RUTA_API + '/usuarios/datosUsuario', {
                    method: 'GET',
                    credentials: 'include'
                });
                const data = await respuesta.json();

                console.log("Respuesta de datos del usuario:", data);
                if (!data.error) {
                    setUsuariosActivos([data.datosUsuario.userId]);
                }
            }


            if (esOwner) {
                console.log("Obteniendo usuarios activos para el grupo:", group_id);
                const respuesta = await fetch(Constantes.RUTA_API + '/miembros_grupos/getMiembros?grupoId=' + group_id, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const data = await respuesta.json();
                console.log("Respuesta de usuarios activos:", data);
                if (!data.error) {
                    setUsuariosActivos(data);
                }
            }
        } catch (error) {
            console.error('Error al obtener los usuarios activos:', error);
        }
    }, [group_id, esOwner]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        fetchUsuariosActivos();

        fetchSolicitudesPendientes();
    }, [esOwner, group_id, fetchUsuariosActivos, fetchSolicitudesPendientes]);

    async function gestionarInvitacionGrupo(usuario, action) {
        try {
            const respuesta = await fetch(Constantes.RUTA_API + '/invitaciones/gestionarInvitacionGrupo', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ grupoId: group_id, usuarioId: usuario, accion: action })
            });
            const data = await respuesta.json();
            alert(data.message);

            fetchUsuariosActivos();

            fetchSolicitudesPendientes();
        } catch (error) {
            console.error('Error al aprobar la solicitud:', error);
        }
    }

    async function borrarGrupo() {
        try {

            const respuesta = await fetch(Constantes.RUTA_API + '/grupos/eliminar/' + group_id, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await respuesta.json();
            alert(data.message);
        } catch (error) {
            console.error('Error al borrar el grupo:', error);
        }
    }

    async function procesarPeticion(e) {
        e.preventDefault()
        try {

            console.log("Enviando datos del grupo:", { group_name, descripcion });

            const respuesta = await fetch(Constantes.RUTA_API + '/grupos/modificar/' + group_id, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ group_name, descripcion })
            })

            const data = await respuesta.json();
            alert(data.message);

        } catch (error) {
            console.error('Error al enviar:', error);
            alert('Hubo un error al enviar el formulario');
        }
    };

    return (
        <>
            <div class="App d-flex justify-content-center bg-dark text-white">

                {esOwner === true &&
                    <>
                        <div className="row justify-content-center text-white">
                            <form onSubmit={procesarPeticion}>
                                <div class="mb-4 mt-4">
                                </div>
                                <div class="mb-4 mt-4">
                                    <label for="nombre_grupo" class="form-label">Nombre del grupo:</label>
                                    <input value={group_name} onChange={(e) => setGroup_Name(e.target.value)} type="nombre_grupo" class="form-control" id="group_name" name="group_name" />
                                </div>
                                <div class="mb-4 mt-4">
                                    <label for="descripcion" class="form-label">Descripción:</label>
                                    <input value={descripcion} onChange={(e) => setDescripcion(e.target.value)} type="description" class="form-control" id="description" name="description" />
                                </div>
                                <button type="submit" class="my-4 btn btn-primary" style={{ width: "100%" }}>Actualizar grupo</button>
                            </form>
                        </div>

                        <div class="row justify-content-center text-white">
                            <div className="col-md-6 mb-4">
                                <h3 className="text-center mb-3">Solicitudes Pendientes</h3>

                                {solicitudesPendientes.length === 0 ? (
                                    <p className="text-center">No hay solicitudes pendientes.</p>
                                ) : (
                                    <ul className="list-unstyled">
                                        {solicitudesPendientes.map((solicitud) => {
                                            return (
                                                <li key={solicitud.id} className="mb-3 p-3 border rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center"
                                                    >
                                                        <strong>Usuario: {solicitud.nombre}</strong>

                                                        <button className="btn btn-success btn-sm" onClick={() => gestionarInvitacionGrupo(solicitud.id, 'aceptar')}>Aprobar</button>
                                                        <button className="btn btn-danger btn-sm" onClick={() => gestionarInvitacionGrupo(solicitud.id, 'rechazar')}>Rechazar</button>

                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>

                            <div className="col-md-6 mb-4">
                                <h3 className="text-center mb-3">Usuarios activos</h3>

                                {usuariosActivos.length === 0 ? (
                                    <p className="text-center">No hay usuarios activos.</p>
                                ) : (
                                    <ul className="list-unstyled">
                                        {usuariosActivos.map((usuario) => {
                                            return (
                                                <li key={usuario.id} className="mb-3 p-3 border rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center"
                                                    >
                                                        <strong>Usuario: {usuario.nombre}</strong>
                                                        <button className="btn btn-danger btn-sm" onClick={() => expulsarUsuario(usuario.id)}>Expulsar</button>

                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>
                            <div className="col-md-12 mb-4 text-center ">
                                <h3 className="text-center mb-3">Borrar grupo</h3>
                                <button className="btn btn-danger btn-lg " onClick={() => borrarGrupo()}>Borrar grupo</button>
                            </div>
                        </div>
                    </>
                }
                {esOwner === false &&

                    <div className="row justify-content-center text-white">
                        <div className="col-md-6 mb-4 text-center">
                            <h3 className="text-center mb-3">Detalles del grupo</h3>

                            <p><strong>Nombre del grupo:</strong> {group_name}</p>
                            <p><strong>Descripción:</strong> {descripcion}</p>
                            <button className="btn btn-danger btn-sm" onClick={() => expulsarUsuario(usuariosActivos[0])}>Salir del grupo</button>

                        </div>
                    </div>
                }

            </div>
            <title>configuracion de grupo {group_name}</title>
        </>
    );
}



export default ConfiguracionGrupo;